<template>
  <div>
    <GraphTitle
      :active-search="activeSearch"
      :city="cityName"
      :direction="direction"
    >
      <span v-if="daysDifference">
        {{
          `(${$t(
            'search.nearestSearchesRoundTrip.daysDifference',
            daysDifference,
          )})`
        }}
      </span>
    </GraphTitle>
    <PricesGraph
      :direction="direction"
      :searches="searches"
      @onActiveDateChange="emit('onActiveDateChange', $event)"
    />
  </div>
</template>

<script setup lang="ts">
  import GraphTitle from './GraphTitle.vue';
  import PricesGraph from './PricesGraph.vue';
  import type { GraphDirection, MappedRoundTripNearestSearch } from '../types';

  defineProps<{
    direction: GraphDirection;
    searches: MappedRoundTripNearestSearch[];
    activeSearch: MappedRoundTripNearestSearch;
    cityName: string;
    daysDifference?: number;
  }>();

  const emit = defineEmits<{ onActiveDateChange: [id: number] }>();
</script>
